export default {
  header: {
    newValuation: "新的估值",
    balances: "余额",
    allCases: "全部案例",
    allDrafts: "全部草稿",
    language: "语言",
    languageChinese: "中文",
    languageEnglish: "English",
    profile: "个人资料",
    logout: "退出登录",
    unlocked: "解锁报告",
    history: "历史记录",
  },

  profile: {
    email: "邮箱",
    prepaidBalance: "预付余额",
    pocBalance: "POC余额",
    startup: "初创公司",
    patent: "专利",
    team: "团队",
  },

  qa: {
    chatPlaceholder: "请输入",
    tips: "请输入您想估值的专利或公司名称",
    quickValuationReview: "快速估值回顾",
    cannotInput: "选择时暂不可输入",
    unlockSuccess: "解锁成功，报告生成中，预计需要30分钟。",
    unlockFailed: "余额不足，请联系管理员",
    unlockTips:
      "估值完成，您还有{balance}次付费点数，{poc_balance}次POC点数，请选择您要解锁的章节？",
    unlockCost: "消耗{cost}次点数",
    downloadReport: "正在下载报告，请稍后...",
    downloadCertificate: "正在下载证书，请稍后...",
    reportGenerating: "报告生成中...",
    certificateGenerating: "证书生成中...",

    reportResult: "报告结果如下",
    valuationResult: "估值结果",

    reportTimeout: "报告生成超时，请稍后刷新页面查看结果",
    unknownError: "未知错误，请联系管理员",
    confirmSubmit: "确认提交",

    cannotRecognize: "无法识别，请重新输入！",

    noSelect: "请选择要解锁的章节",
  },

  form: {
    valuationType: "估值类型",
    valuationTips: "请选择估值类型",
    companyNameOrPatentId: "公司名称/专利号",
    companyNameOrPatentIdTips: "请输入公司名称/专利号",
    company: "公司",
    patent: "专利",
  },

  searcch: {
    placeholder: "请输入ID或草稿名称搜索",
    placeholder2: "请输入ID或案例名称搜索",
  },

  table: {
    id: "ID",
    caseName: "案例名称",
    draftName: "草稿名称",
    status: "状态",
    action: "操作",
    createTime: "创建时间",
    noMore: "没有更多了",
    pending: "待处理",
    executing: "提交中",
    finished: "已完成",
    failed: "生成失败",
    unknown: "未知",
  },

  common: {
    confirm: "确认",
    cancel: "取消",
    submit: "提交",
    reset: "重置",
    report: "报告",
    viewReport: "查看报告",
    certificate: "证书",
    viewCertificate: "查看证书",
    search: "搜索",
    delete: "删除",
    edit: "编辑",
    add: "添加",
    save: "保存",
    loading: "加载中...",
    success: "成功",
    error: "错误",
    warning: "警告",
    info: "提示",
    unlock: "解锁",

    downloadCompleted: "下载完成",
    downloadFailed: "下载失败",
    downloadCancelled: "下载已取消",
    networkError: "网络错误",
  },

  login: {
    title: "登录 OxValue.AI",
    email: "邮箱",
    enterEmail: "请输入邮箱",
    code: "验证码",
    enterCode: "请输入验证码",
    invitationCode: "邀请码（选填）",
    enterInvitationCode: "请输入邀请码",
    loginButton: "登录",
    sendCode: "发送验证码",
    resendCode: "{time}秒后重新发送",
    errors: {
      codeError: "请输入4位验证码",
      loginError: "邮箱或验证码错误！",
      emailRequired: "请输入邮箱",
      codeRequired: "请输入验证码",
      invalidEmail: "请输入有效的邮箱地址",
    },
  },
};
